import AppHeader from '@components/AppNavigation/AppHeader';
import FlowsTable from '@components/Flows/FlowsTable';
import React, { FC } from 'react';

const FlowsPage: FC = () => (
	<>
		<AppHeader translation="pages.flows.title" />
		<FlowsTable />
	</>
);

export default FlowsPage;
